export interface Fee {
	name: string;
	filing_fee: string;
	miscellaneous_fee: string;
	total: string;
}

const fees: Fee[] = [
	{
		name: "JDF",
		filing_fee: "0.00",
		miscellaneous_fee: "PHP 300.80",
		total: "PHP 300.80",
	},
	{
		name: "SAJF",
		filing_fee: "0.00",
		miscellaneous_fee: "PHP 1,000",
		total: "PHP 1,000",
	},
	{
		name: "Total Amount to be Paid",
		filing_fee: "0.00",
		miscellaneous_fee: "1,300.80",
		total: "PHP 1,300.80",
	},
];

export default fees;
